import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_104: FaireProductEntity = {
  token: "legacy_prod_abbott-104",
  type: "product",
  name: 'Horse Head Planter 9" H',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/426480611649eafaa3d92e31652bf337cd90e3ab8281fe31bf57b415ee1a5ab3.jpeg",
  priceDollars: 42,
  subcategory: "Planters",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_garden-outdoor"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
